import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { SettingsService } from '../api/services/settings';
import { State } from '../store/interfaces';
import {
  masterDataErrorAction,
  masterDataLoadedAction,
  requestMasterDataAction,
} from '../store/reducers/master-data';

export const useMasterData = (settingsService: SettingsService) => {
  const masterData = useSelector((state: State) => state.masterData);
  const dispatch = useDispatch();
  const loadMasterData = useCallback(async () => {
    dispatch(requestMasterDataAction());
    try {
      const data = await settingsService.getMasterData();
      dispatch(masterDataLoadedAction(data));
    } catch (e) {
      dispatch(masterDataErrorAction(e));
    }
  }, [dispatch, settingsService]);
  useEffect(() => {
    if (!masterData.loaded && !masterData.loading) {
      loadMasterData();
    }
  }, [masterData, loadMasterData]);

  return {
    ...masterData,
    loadMasterData,
  };
};
